<template>
  <div>
    <div class="widM">
      <p class="fntH6 fntL bold padTS" style="color:#20893d;">{{ activity.title }}</p>
    </div>
    <hr :style="seq === 0 ? { 'border-bottom' : '1px solid #e3e3e3'} : { 'border-top' : '1px solid #e3e3e3'}">
    <div class="widM">
      <div class="clearfix">
        <template v-for="(attendant, idx) in attendingList">
          <div :key="`${seq}${idx}`">
            <div :class="(idx % 2) === 0 ? 'floL' : 'floR'">
              <p class="fntH6 fntL bold padBSM" style="color:#2c2c2c;">{{ getTextByType(attendant.type, attendant.type_seq) }} 액티비티</p>
              <div class="amway-theme">
                <div class="radio-wrapper NCACroa_cont03_radio NCACroa_radioBtn">
                  <SurveyExample
                    v-for="(example, se_code) in activity.examples"
                    :key="`${se_code}_${seq}${idx}`"
                    class="amw-radio-wrap radio-label focus disBl"
                    :example="example"
                    :attendant="attendant"
                    :res-idx="getDataIdx(attendant.type, attendant.type_seq)"
                    :prev-selected="isPrevSelectedExample(se_code, attendant)"
                    :unique="`${seq}${idx}`"
                  />
                </div>
              </div>
            </div>
          </div>
          <hr
            v-if="idx < attendingList.length - 1"
            :key="`hr${seq}${idx}`"
            class="moOnly"
            style="border-top:1px solid #e3e3e3;"
          />
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { SURVEY, ATTENDING_LIST, GET_DATA_IDX_BY_TYPE } from '@/store/actions/survey'
import { CommonMethodMixin } from '../mixins'
import SurveyExample from './SurveyExample.vue'

export default {
  name: 'SurveyActivity',
  mixins: [CommonMethodMixin],
  components: {
    SurveyExample,
  },
  props: {
    activity: {
      type: Object,
      required: true
    },
    seq: {
      type: Number,
      required: true
    }
  },
  computed: {
    ...mapState(SURVEY, {
      originals: state => state.originals
    }),
    ...mapGetters(SURVEY, {
      getDataIdx: GET_DATA_IDX_BY_TYPE,
      attendingList: ATTENDING_LIST
    }),
  },
  methods: {
    isPrevSelectedExample(se_code, attendant) {
      if(this.originals) {
        const idx = this.getDataIdx(attendant.type, attendant.type_seq);
        const originalResponse = this.originals[idx];
        if(originalResponse && originalResponse.questions && originalResponse.questions[this.activity.sq_code]) {
          return originalResponse.questions[this.activity.sq_code].se_code === se_code;
        } else {
          return false;
        }
      } else {
        return false;
      }
    }
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/survey/components/SurveyActivity.vue